import { render, staticRenderFns } from "./MyOrders.vue?vue&type=template&id=54536360&scoped=true&"
import script from "./MyOrders.vue?vue&type=script&lang=js&"
export * from "./MyOrders.vue?vue&type=script&lang=js&"
import style0 from "./MyOrders.vue?vue&type=style&index=0&id=54536360&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54536360",
  null
  
)

export default component.exports